<script setup lang="ts">
/**
 * BO Notice 공통 레터헤드 — 회사 · 일자 · 문서별 싸인대상(수신자).
 */
import { computed } from 'vue';
import BoNoticeDocVarField from '../BoNoticeDocVarField.vue';
import type { BoNoticeRecipientMode } from '../boNoticeFields';

const props = withDefaults(defineProps<{
  parenReg?: boolean;
  recipientMode?: BoNoticeRecipientMode;
}>(), {
  parenReg: true,
  recipientMode: 'individual_member',
});

const nameKey = computed(() => {
  switch (props.recipientMode) {
    case 'corporate_member': return 'corporate_member_name';
    case 'individual_member': return 'member_name';
    case 'suspected_bo':
    case 'registered_bo': return 'bo_name';
    case 'info_holder': return 'info_holder_name';
    default: return 'member_name';
  }
});

const addressKey = computed(() => {
  switch (props.recipientMode) {
    case 'corporate_member': return 'corporate_member_address';
    case 'individual_member': return 'member_address';
    case 'suspected_bo':
    case 'registered_bo': return 'bo_address';
    case 'info_holder': return 'info_holder_address';
    default: return 'member_address';
  }
});

const isMember = computed(() =>
  props.recipientMode === 'corporate_member' || props.recipientMode === 'individual_member',
);
</script>

<template>
  <div class="bo-letter-head">
    <div class="doc-head">
      <div class="doc-company"><BoNoticeDocVarField field-key="company_name" /></div>
      <div v-if="parenReg" class="doc-meta">
        (Company Registration No. <BoNoticeDocVarField field-key="company_registration_no" />)
      </div>
      <div v-else class="doc-meta">
        Company Registration No. <BoNoticeDocVarField field-key="company_registration_no" />
      </div>
      <div class="doc-meta" style="margin-top:2px">
        <BoNoticeDocVarField field-key="registered_office_address" />
      </div>
    </div>

    <p class="doc-p"><b>Date :</b> <BoNoticeDocVarField field-key="notice_date" /></p>

    <p v-if="isMember" class="doc-p" style="padding-top:8px">
      <BoNoticeDocVarField :field-key="nameKey" /><br />
      Member of <BoNoticeDocVarField field-key="company_name" /><br />
      <BoNoticeDocVarField :field-key="addressKey" />
    </p>
    <p v-else class="doc-p" style="padding-top:8px">
      <BoNoticeDocVarField :field-key="nameKey" /><br />
      <BoNoticeDocVarField :field-key="addressKey" />
    </p>

    <p class="doc-p">Dear Sir/Madam,</p>
  </div>
</template>
